import { type ReactNode } from 'react';
import { type ZoneModels } from '@models/Zone';
import { withFallback } from '@models/withFallback';
import { formatDate } from '@utils/dateFormatUtils';
import { HeaderSummary } from './HeaderSummary';

interface DetailsSectionProps {
    standard: ZoneModels.Standard;
}

export function DetailsSection({ standard }: DetailsSectionProps): ReactNode {
    return (
        <div className="flex flex-1 flex-column gap-4">
            <div className="flex justify-content-between">
                <HeaderSummary
                    name="Requirements:"
                    value={standard.requirementsCount.toString()}
                />
                <HeaderSummary
                    name="Released:"
                    value={formatDate(standard.releasedAt)}
                />
                <HeaderSummary
                    name="Valid:"
                    value={
                        formatDate(standard.validFrom) +
                        (standard.validTo
                            ? ` - ${formatDate(standard.validTo)}`
                            : '')
                    }
                />
                <HeaderSummary
                    name="Country:"
                    value={withFallback(standard.country?.name)}
                />
            </div>
            <HeaderSummary name="Description:" value={standard.description} />
            <HeaderSummary
                name="Implementation guidance:"
                value={withFallback(standard.implementationGuidance)}
            />
        </div>
    );
}
